import React, { FC, PropsWithChildren } from 'react';
import { PWAInstallProvider } from 'global/pwa/use-pwa';
import { QueryClientProvider, QueryClient } from 'react-query';
import { RecoilRoot } from 'recoil';
import { RecoilDevTools } from 'recoil-gear';
import { ToastContainer } from 'react-toastify';
import { ModalsProvider } from 'common/modals';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

export const AppProviders: FC<PropsWithChildren<any>> = ({ children }) => (
  <>
    <ToastContainer
      autoClose={5000}
      closeOnClick
      draggable
      hideProgressBar
      newestOnTop={false}
      pauseOnFocusLoss
      pauseOnHover
      position="top-right"
      rtl={false}
    />
    <RecoilRoot>
      {process.env.NODE_ENV !== 'production' && <RecoilDevTools />}
      <QueryClientProvider client={queryClient} contextSharing>
        <ModalsProvider />
        <PWAInstallProvider>{children}</PWAInstallProvider>
      </QueryClientProvider>
    </RecoilRoot>
  </>
);
